import { ActionSuccess, ActionFailure } from './Common';

export const UPDATE_SCHOOL_INFO = 'UPDATE_SCHOOL_INFO';
export type UPDATE_SCHOOL_INFO = typeof UPDATE_SCHOOL_INFO;

export interface SchoolInfoFields {
    schoolId: string;
    name?: string;
    logoPreviewFile?: any;
    backgroundPreviewFile?: any;
    activities?: string[];
}

export interface UpdateSchoolInfo {
    type: UPDATE_SCHOOL_INFO;
    value: SchoolInfoFields;
}

export type SchoolOnboardAction =
    | UpdateSchoolInfo
    | ActionSuccess
    | ActionFailure;

export function updateSchoolInfo(value: SchoolInfoFields): UpdateSchoolInfo {
    return {
        type: UPDATE_SCHOOL_INFO,
        value: value
    };
}
